export enum ShapeType {
    Unspecified = 1,
    NewShape = 2,
    OldShape = 3
}